module.exports = __webpack_public_path__ + "img/logout.c483d29e.svg";